import { Plugin } from "prosemirror-state";
import { Slice, Fragment, Schema, NodeType, Node } from "prosemirror-model";

export const pastingHandler = (
  fragment: Fragment,
  regexp: RegExp,
  type: string,
  getAttrs,
  schema: Schema
) => {
  const nodes: Node[] = [];

  fragment.forEach((child: Node) => {
    if (child.isText) {
      const { text } = child;
      let pos = 0;
      let match: RegExpExecArray;

      // eslint-disable-next-line
      while ((match = regexp.exec(text)) !== null) {
        if (match[0]) {
          const start = match.index;
          const end = start + match[0].length;

          // adding text before markdown to nodes
          if (start > 0) {
            if (text.substring(pos, start)) nodes.push(child.cut(pos, start));
          }

          const node = Node.fromJSON(schema, {
            type,
          });

          // create the node
          nodes.push(node);

          pos = end;
        }
      }

      // adding rest of text to nodes
      if (pos < text.length) {
        nodes.push(child.cut(pos));
      }
    } else {
      nodes.push(
        child.copy(
          pastingHandler(child.content, regexp, type, getAttrs, schema)
        )
      );
    }
  });

  return Fragment.fromArray(nodes);
};

export function nodePasteRuleHardBreak(
  regexp: RegExp,
  type: string,
  getAttrs,
  schema: Schema
) {
  return new Plugin({
    props: {
      transformPasted: (slice) =>
        new Slice(
          pastingHandler(slice.content, regexp, type, getAttrs, schema),
          slice.openStart,
          slice.openEnd
        ),
    },
  });
}
